<template>
  <transition-group v-show="isVisible" tag="div" class="alerts" name="alerts">
    <div
      class="alerts-card"
      v-for="item of alerts"
      :key="`alert${item.id}`"
      @click="removeAlert(item.id)"
    >
      <BaseSvgIcon name="green_check" class="alert-card__icon" />
      <p class="alert-card__body">{{ item.text }}</p>
    </div>
  </transition-group>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import BaseSvgIcon from "@/shared/ui/BaseSvgIcon/BaseSvgIcon.vue";
import "@/assets/icons/SVG/green_check.svg";

export default {
  name: "VAlerts",
  components: { BaseSvgIcon },
  computed: {
    ...mapState("alerts", ["alerts"]),
    ...mapGetters("alerts", ["isVisible"]),
  },
  methods: {
    ...mapActions("alerts", ["REMOVE_ALERT"]),
    removeAlert(id) {
      this.REMOVE_ALERT(id);
    },
  },
};
</script>

<style scoped lang="scss">
.alerts {
  position: fixed;
  bottom: 70px;
  right: 20px;
  z-index: 100;
  max-width: 560px;
  transition: all 0.5s ease;

  &-card {
    display: flex;
    border-radius: 10px;
    padding: 10px;
    border: 1px solid var(--bg-6);
    background: var(--bg-3);
    color: #ffffff;
    margin-bottom: 10px;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
}
</style>
